/* istanbul ignore file
framework test cases are tested in platform only so excluding here */
import { Framework, init } from '../common/Framework';
import { logger, setGlobalContext } from '../common/logger';
// Import containers
import App from './App';
import { PAGE_NAME } from './constant';

import '../common/Loader/styles/default.css';

setGlobalContext();
logger.addLoggerContext('module', PAGE_NAME);

// Create instance of framework
const FrameworkIns = new Framework({ modelPath: `${process.env.PUBLIC_URL}/models`, configId: 'login.json' });
// const FrameworkIns = new Framework({ modelPath: 'http://localhost:1337/fibis', configId: '1', strapi: true });

// Register components
// Register components{ modelPath: 'http://localhost:1337/fibis', configId: '10', strapi: true }
FrameworkIns.register('OktaLogin', App);

// Get all component identifier elements
const nodeList = document.querySelectorAll('[data-component]');
logger.info(`Framework: Component identified in DOM - ${PAGE_NAME}`);

(async function initFrame() {
  // Begin rendering
  init(FrameworkIns, nodeList);
})();
